export default __webpack_public_path__ + "static/media/travis-ci.71a25d20.svg";